import layoutView from "./layoutView";
import mobileBase from "./common/mobileBase";
/**
 * 移动端配置页面基类
 */
export default {
  mixins: [layoutView, mobileBase],
  data() {
    return {
      fromPath: "",
      _pagings: [],
      //分页容器专用变量
      _pagingIndex: 0
    };
  },
  computed: {
    $pagings() {
      return this._data._pagings;
    },
    $pagingIndex: {
      get() {
        return this._data._pagingIndex;
      },
      set(v) {
        this._data._pagingIndex = v;
      }
    },
    isShowNavsBar(){
      return this.$attrs['is-show-nav-bar'];
    }
  },
  created() {
    try {
      if (!this.$dialog) {
        let index = _.findIndex(dsf.global.$$state.routeChain, (v) => v.path == this.$route.path);
        let preViewContext = window.$$state.routeChain[index - 1];
        if (preViewContext) {
          let preView = this.$store.getters["keepAlive/instances"][preViewContext.path];
          if (preView) {
            this.$openerVm = preView.vm;
            if (dsf.global.$windowArgs && dsf.global.$windowArgs[this.$route.path]) {
              this.$dialogArgs = dsf?.global?.$windowArgs[this.$route.path];
            } else {
              this.$dialogArgs = null;
            }
          }
        }
      } else {
        this.$dialogArgs = this.$dialog.dialogArgs || null;
        this.$openerVm = this.$dialog.openerVm;
      }
    } catch (ex) {
      dsf.error(ex);
    }
  },
  activated() {
    if (this.$isLoaded) {
      //检测当前页是否在刷新队列中,如果在则刷新数据
      this.$popRefresh();
      //还原上次滚动条滚动的位置
      if (this.$el && this.$el.nodeType == 1) {
        const $content = this.$el.querySelectorAll("[scroll-id]");
        let scrolls = this.$route.meta.scrolls;
        _.each($content, (el) => {
          let sid = el.getAttribute("scroll-id");
          let scroll = scrolls[sid];
          if (scroll) {
            el.scroll(scroll.x, scroll.y);
            delete scrolls[sid];
          }
        });
      }
    }
  },
  mounted() {
    this.$popRefresh(false);
    let index = _.findLastIndex(window.$$state.routeChain, (it, i) => {
      return it.path == this.$route.path;
    });
    let last = null;
    if (index >= 0) {
      last = window.$$state.routeChain[index - 1];
    }
    this.fromPath = last || null;
  },
  methods: {
    $closeWindow() {
      let dialog = this.$dialog;
      if (dialog) {
        dialog.close();
      } else if (this.$openerVm) {
        this.$router.back();
      } else if (window.uni && this.$route.query.mpaction == "back") {
        uni.navigateBack();
      } else {
        window.history.go(-1);
      }
    },
    reloadParentViewData() {
      if (dsf.global.$isMobile && dsf.global.$$state) {
        let last = null;
        if (this.fromPath) {
          last = this.fromPath;
        } else {
          last = window.$$state.routeChain[window.$$state.routeChain.length - 2];
        }
        if (last && last.path && last.path != "/") {
          this.$store && this.$pushRefresh(last.path);
        }
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   next()
  // },
  //全局混入页面离开的路由操作,离开时记录所有打了scroll-id标记容器的滚动条位置
  beforeRouteLeave(to, from, next) {
    if (this.$el && this.$el.nodeType == 1) {
      const $content = this.$el.querySelectorAll("[scroll-id]");
      let scrolls = {};
      _.each($content, (el) => {
        let sid = el.getAttribute("scroll-id");
        scrolls[sid] = { y: el.scrollTop, x: el.scrollLeft };
      });
      if (from && from.meta) {
        from.meta.scrolls = scrolls;
      }
    }
    next();
  },
  beforeDestroy() {
    //清理掉$openWindow传递的参数
    if (dsf.global.$windowArgs) {
      delete dsf.global.$windowArgs[this.$route.path];
    }
  }
};
